import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { experiences } from "../constants/index";
import Certifications from "../../pages/Certifications";

const ExperienceCard = ({ experience }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        background: "rgba(255, 255, 255, 0.05)",
        color: "#fff",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(12px)",
        borderRadius: "1.5rem"
      }}
      contentArrowStyle={{ borderRight: "7px solid rgba(255, 255, 255, 0.1)" }}
      date={experience.date}
      iconStyle={{ background: experience.iconBg }}
      icon={
        <div className='flex justify-center items-center w-full h-full'>
          <img
            src={experience.icon}
            alt={experience.company_name}
            className= {`w-[95%] h-[95%] object-contain rounded-full ${experience.class}` }
          />
        </div>
      }
    >
      <div>
        <h3 className='text-white text-[20px] font-bold tracking-wide'>{experience.title}</h3>
        <p
          className='text-cyan-300 text-[14px] font-semibold mt-1'
          style={{ margin: 0 }}
        >
          {experience.company_name}
        </p>
      </div>

      <ul className='mt-5 list-disc ml-5 space-y-2.5'>
        {experience.points.map((point, index) => (
          <li
            key={`experience-point-${index}`}
            className='text-gray-300 text-[13px] pl-1 tracking-wider leading-relaxed'
          >
            {point}
          </li>
        ))}
      </ul>
    </VerticalTimelineElement>
  );
};

const Experience = () => {
  return (
    <section id="work" className="px-4 md:px-10 py-24 bg-transparent text-white max-w-7xl mx-auto relative z-0">
      <div className="mb-10">
        <p className="text-xs tracking-[0.35em] text-white/60 uppercase text-center">
          What I have done so far
        </p>
        <h2 className="mt-3 text-4xl md:text-5xl font-bold text-center">
          Journey
        </h2>
      </div>

      <div className='mt-10 flex flex-col'>
        <VerticalTimeline >
          {experiences.map((experience, index) => (
            <ExperienceCard
              key={`experience-${index}`}
              experience={experience}
            />
          ))}
        </VerticalTimeline>
      </div>
      <Certifications />
    </section>
  );
};

export default Experience;
